import { addNotify } from 'features/Notify';
import { actions as megaWinsActions } from 'features/MegaWins';
import { actions as authActions } from 'features/Auth';
import { actions as historyActions } from 'features/History';

const actionTypes = {
  GET_SETTINGS_SUCCESS: 'game/GET_SETTINGS_SUCCESS',
  SET_START_INFO: 'game/SET_START_INFO',
  COMPLETE_GAME: 'game/COMPLETE_GAME',
  SET_IS_PROCESS: 'game/SET_IS_PROCESS',
  START_GAME: 'game/START_GAME',
  END_GAME: 'END_GAME',
  SET_GAME_SETTINGS: 'game/SET_GAME_SETTINGS',
  PICK: 'game/PICK',
  WON: 'game/WON',
  LOST: 'game/LOST',
}

const getSettings = data => async (dispatch, _, { themeMap }) => {
  const themeNames = Object.keys(themeMap);
  dispatch({ type: actionTypes.GET_SETTINGS_SUCCESS, payload: { ...data, themeNames } });
}

const setStartInfo = data => dispatch => {
  dispatch({ type: actionTypes.SET_START_INFO, payload: data })
}

const startGame = callback => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { currency, token, userID, balance} = getState().auth;
  const { locale } = getState().locale;
  const { isProcess, gameSettings } = getState().game;
  if (!isProcess) {
    dispatch({ type: actionTypes.SET_IS_PROCESS, payload: true });
    const response = await api.game.startGame({
      amount: gameSettings.amount,
      pyramid_height: gameSettings.rowsCount,
      risk: gameSettings.riskLevel,
      balls_count: gameSettings.ballsCount,
      }, token);
    if (response.success) {
      dispatch(authActions.getBalance(balance - gameSettings.amount * gameSettings.ballsCount.toFixed(3)));
      response.data.roads.forEach((road, i) => {
        dispatch({ type: actionTypes.START_GAME, payload: { 
          road: road, 
          gameID: `${response.data.game_id}_${i}`,
          roundID: response.data.game_id,
          winning: response.data.win_amount,
          newBalance: response.data.new_balance,
          amount: gameSettings.amount,
        } })
      });
      dispatch(historyActions.pushNewBet({
        game_id: response.data.game_id,
        bet_amount: gameSettings.amount,
        user_id: userID,
        win_amount: response.data.win_amount,
      }));
      dispatch(addNotify(locale.placeBetSuccess(gameSettings.amount * gameSettings.ballsCount, currency), 'success'));
      if (callback) {
        callback();
      }
    } else {
      dispatch(addNotify(locale.errorMessages[response?.codeStatus?.toString()] || locale.errorMessages.defaultMessage, 'error'));
    }
    dispatch({ type: actionTypes.SET_IS_PROCESS, payload: false });
  }
}

const endGame = game => async (dispatch, getState) => {
  const { locale } = getState().locale;
  const { currency } = getState().auth;
  const { activeBalls } = getState().game;
  const ball = activeBalls.find(item => item.gameID === game.gameID);
  dispatch({ type: actionTypes.END_GAME, payload: { gameID: game.gameID } })
  if (activeBalls.filter(item => item.roundID === ball.roundID).length === 1) {
    if (game.winning / ball.amount >= 15) {
      dispatch(megaWinsActions.showMegaWins(game.winning.toFixed(2)));
    } else {
      dispatch(addNotify(`${locale.youWon} ${game.winning.toFixed(2)} ${currency}`, 'win'))
    }
    dispatch(authActions.getBalance(ball.newBalance));
  }
}

const setGameSettings = data => async dispatch => {
  dispatch({ type: actionTypes.SET_GAME_SETTINGS, payload: data });
}

export {
  actionTypes,
  getSettings,
  setStartInfo,
  setGameSettings,
  startGame,
  endGame,
}